<template>
	<div class="row h-row-inputBox">
		<div class="h-nsmf-inputLit">{{$t('NSMF.nsmfBusiness')}}</div>
		<div class="h-inputLit">{{$t('NSMF.maxMumberOfUe')}}:<span>{{maxMumberOfUe}}</span></div>
		<!--业务饼图-->
        <div class="col-sm-6 h-col-inputBox col-nsmf-div col-nsmf-div-t">
          <div class="form-group">
            <div class="e-float-input">
            	<div id="business_pie_chart" style="width: 300px;height: 250px;"></div>
            </div>
          </div>
        </div>
		<!--开户数-折线图-->
        <div class="col-sm-6 h-col-inputBox col-nsmf-div col-nsmf-div-t">
          <div class="form-group">
            <div class="e-float-input">
				<div id="nember_discount" style="width: 300px;height: 250px;"></div>
            </div>
          </div>
        </div>
		<!--吞吐量-折线图-->
        <div class="col-sm-6 h-col-inputBox col-nsmf-div col-nsmf-div-t">
          <div class="form-group">
            <div class="e-float-input">
				<div id="throughput_discount" style="width: 300px;height: 250px;"></div>
            </div>
          </div>
        </div>
		<!--物理饼图-->
		<div class="h-nsmf-inputLit">{{$t('NSMF.nsmfPhysical')}}</div>
        <div class="col-sm-6 h-col-inputBox col-nsmf-div">
          <div class="form-group">
            <div class="e-float-input">
				<div id="physics_pie_chart" style="width: 300px;height: 250px;"></div>
            </div>
          </div>
        </div>
		<!--CPU-折线图-->
        <div class="col-sm-6 h-col-inputBox col-nsmf-div">
          <div class="form-group">
            <div class="e-float-input">
				<div id="cpu_discount" style="width: 300px;height: 250px;"></div>
            </div>
          </div>
        </div>
		<!--内存-折线图-->
        <div class="col-sm-6 h-col-inputBox col-nsmf-div">
          <div class="form-group">
            <div class="e-float-input">
				<div id="memory_discount" style="width: 300px;height: 250px;"></div>
            </div>
          </div>
        </div>
	</div>
</template>
<script>
	import echarts from 'echarts'
	export default {
		name: '',
		data() {
			return {
				charts: '',
				nsiId: '',
				maxMumberOfUe: '',
				monitorNSITimer: null,
			}
		},
		created() {
		    this.monitorNSITimer = setInterval(this.monitorNSI, 60000);
		},
		beforeDestroy() {
			if (this.monitorNSITimer) {
				clearInterval(this.monitorNSITimer);
				this.monitorNSITimer = null;
			}
		},
		methods: {
      		findMonitorNSI(id) {
				this.nsiId=id;
				this.monitorNSI();
			},
      		monitorNSI() {
        		console.log(this.nsiId);
				//业务资源
				this.axios.post('/lte/ems/networkSlice/businessMonitor/' + this.nsiId).then(response => {
					if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
						//获取数据
						const result = response.data.resultVal;
						this.maxMumberOfUe = result.maxMumberOfUe + '（个）';
						const nemberPercentage = result.nemberPercentage;
						const nemberDateList = result.nemberDateList;
						const nemberTimeList = result.nemberTimeList;
						const throughputPercentage = result.throughputPercentage;
						const downlinkDataList = result.downlinkDataList;
						const uplinkDataList = result.uplinkDataList;
						const throughputTimeList = result.throughputTimeList;
						var maxValue = 1;
						for (var i = 0; i < downlinkDataList.length; i++) {
							var temp = parseFloat(downlinkDataList[i]);
							if(temp>maxValue){
								maxValue = Math.ceil(temp);
							}
						}
						for (var i = 0; i < uplinkDataList.length; i++) {
							var temp = parseFloat(uplinkDataList[i]);
							if(temp>maxValue){
								maxValue = Math.ceil(temp);
							}
						}
						//对比开户数、吞吐量百分比
						var businessTilName = nemberPercentage >= throughputPercentage ? this.$t('NSMF.nsmfNember') : this.$t('NSMF.nsmfThroughput');
						var businessPercentage = nemberPercentage >= throughputPercentage ? nemberPercentage : throughputPercentage;
						var businessColor = businessPercentage >= 0.8 ? '#E50015' : '#244CDC' ;
						//业务资源使用百分比最大值
						this.drawPieChartOnLine('business_pie_chart', businessTilName, businessTilName, businessPercentage, '');
						//开户数
						this.drawLine('nember_discount', this.$t('NSMF.nsmfNember'), nemberDateList, nemberTimeList, '（个）');
						//吞吐量
						this.drawLines('throughput_discount',this.$t('NSMF.downlinkName'),this.$t('NSMF.uplinkName'), downlinkDataList, uplinkDataList, throughputTimeList, '（Gbps）', maxValue);
					}
				});
				//物理资源
				this.axios.post('/lte/ems/networkSlice/physicsMonitor/' + this.nsiId).then(response => {
					if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
						//获取数据
						const result = response.data.resultVal;
						const cpuPercentage = result.cpuPercentage;
						const cpuDateList = result.cpuDateList;
						const cpuTimeList = result.cpuTimeList;
						const memoryPercentage = result.memoryPercentage;
						const memoryDateList = result.memoryDateList;
						const memoryTimeList = result.memoryTimeList;
						//对比CPU、内存百分比
						var physicsTilName = cpuPercentage >= memoryPercentage ? this.$t('NSMF.nsmfCpu') : this.$t('NSMF.nsmfMemory');
						var physicsPercentage = cpuPercentage >= memoryPercentage ? cpuPercentage : memoryPercentage;
						var physicsColor = physicsPercentage >= 0.8 ? '#E50015' : '#244CDC' ;
						//物理资源使用百分比最大值
						this.drawPieChart('physics_pie_chart', physicsTilName, physicsTilName, physicsPercentage, physicsColor, '%');
						//开户数
						this.drawLine('cpu_discount', this.$t('NSMF.nsmfCpu'), cpuDateList, cpuTimeList, '（%）');
						//吞吐量
						this.drawLine('memory_discount',this.$t('NSMF.nsmfMemory'), memoryDateList, memoryTimeList, '（M）');
					}
				});
			},
			//折线图
			drawLine(id, name, dataList, timeList, company) {
				this.charts = echarts.init(document.getElementById(id))
				this.charts.setOption({
					tooltip: {
          				color: "#333",    
						trigger: 'axis',
						formatter: function(params) {
						//自定义函数修改折线图给数据加单位
						var str = ""; //声明一个变量用来存储数据
						str += "<div>" + params[0].name + "</div>"; //显示日期的函数
						for (var i = 0; i < params.length; i++) {
							// console.log(params[1].seriesName,1111111)
							//图显示的数据较多时需要循环数据，这样才可以成功的给多条数据添加单位
							str +=
							'<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' +
							params[i].color +
							';"></span>' +
							params[i].seriesName +
							"</span> : <span>" +
							params[i].data + company +
							"</br>"; 
						}
						return str;
						}
					},
					legend: {
						data: [name],
						x: 'center' ,     
						y: 'bottom' ,         
					},
					grid: {
						left: '3%',
						bottom: '15%',
						containLabel: true
					},
          			color: ['#3E9BE6'],
					toolbox: {
						feature: {
						}
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: timeList
					},
					yAxis: {
						type: 'value',
						name: company
					},
					series: [
						{
							name: name,
							type: 'line',
							data: dataList
						}
					]
				})
			},
			//折线图
			drawLines(id, downlinkName, uplinkName, downlinkDataList, uplinkDataList, timeList, company, maxValue) {
				this.charts = echarts.init(document.getElementById(id))
				this.charts.setOption({
					tooltip: {
          				color: "#333",    
						trigger: 'axis',
						formatter: function(params) {
							//自定义函数修改折线图给数据加单位
							var str = ""; //声明一个变量用来存储数据
							str += "<div>" + params[0].name + "</div>"; //显示日期的函数
							for (var i = 0; i < params.length; i++) {
								//图显示的数据较多时需要循环数据，这样才可以成功的给多条数据添加单位
								str +=
								'<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' +
								params[i].color +
								';"></span>' +
								params[i].seriesName +
								"</span> : <span>" +
								params[i].data + company +
								"</br>"; 
							}
						return str;
						}
					},
					legend: {
						data: [downlinkName, uplinkName],
						x: 'center' ,     
						y: 'bottom' ,         
					},
            		color: ['#3E9BE6', '#FA6F53'], 
					grid: {
						left: '3%',
						bottom: '15%',
						containLabel: true
					}, 
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: timeList
					},
					yAxis: {
						type: 'value',
						min:0,
						max:maxValue,
						name: company
					},
					series: [
						{
							name: downlinkName,
							type: 'line',
							data: downlinkDataList,
							lineStyle: {          
								normal: {
									color: '#3E9BE6',
								}
							},
						},
						{
							name: uplinkName,
							type: 'line',
							data: uplinkDataList,
							lineStyle: {          
								normal: {
									color: '#8AE09F',
								}
							},
						},
					]
				})
			},
			//饼图
			drawPieChart(id, name, tilName, val, color, company) {
				var vala = parseFloat(val/100).toFixed(2);
				this.chartPie = echarts.init(document.getElementById(id));
				this.chartPie.setOption({
					title: {
						text: name,
						x: 'center',  //标题位置 
						y: 'bottom' ,   
					},
					tooltip: {
						trigger: 'item',
						formatter: tilName + " <br/>{b} : {c}" + company,
					},
          			color: [color, '#D4D4D4'],
					series: [{
						name: name,
						type: 'pie',
						radius: ['50%', '65%'],
						center: ['50%', '50%'],
					   	label: {
							normal: {
								show: true,
								position: 'center',
								formatter:function (argument) {
									var html;
									html = vala + company;
									return html;
								},
								textStyle:{
									fontSize: 20,
									color:'#00c0ef'
								}
							}
						},
						startAngle:270, //起始角度
						data: [//每个模块的名字和值
							{ name: this.$t('NSMF.nsmfUsed'), value: vala },
							{ name: this.$t('NSMF.nsmfNotUsed'), value: parseFloat(1-vala).toFixed(2) },
						],
					}]
				});
			},
			//饼图
			drawPieChartOnLine(id, name, tilName, val, company) {
				this.chartPie = echarts.init(document.getElementById(id));
				this.chartPie.setOption({
					title: {
						text: name,
						x: 'center',  //标题位置 
						y: 'bottom' ,   
					},
					tooltip: {
						trigger: 'item',
						formatter: tilName + " <br/>{b} : " + val + company,
					},
          			color: ['#D4D4D4'],
					series: [{
						name: name,
						type: 'pie',
						radius: ['50%', '65%'],
						center: ['50%', '50%'],
					   	label: {
							normal: {
								show: true,
								position: 'center',
								formatter:function (argument) {
									var html;
									html = val + company;
									return html;
								},
								textStyle:{
									fontSize: 20,
									color:'#00c0ef'
								}
							}
						},
						startAngle:270, //起始角度
						data: [//每个模块的名字和值
							{ name: this.$t('NSMF.nsmfNember'), value: 1 },
						],
					}]
				});
			},
		},
	}
</script>
<style scoped>
	* {
		margin: 0;
		list-style: none;
	}
	.col-nsmf-div-t{
		margin-bottom:35px;
	}
</style>